import DOMPurify from 'dompurify'
import styles from './Text.module.css'

type Props = {
  children: React.ReactNode
  className?: string
  style?: React.CSSProperties
}

function Text(props: Props) {
  return (
    <pre
      className={`${styles.text} ${props.className ?? ''}`}
      style={props.style}
    >
      {props.children}
    </pre>
  )
}

function SectionText({
  children,
  style
}: {
  children: React.ReactNode
  style?: React.CSSProperties
}) {
  // If children is a string (potentially HTML from rich text editor), sanitize and render as HTML
  if (typeof children === 'string') {
    const sanitizedHTML = DOMPurify.sanitize(children, {
      ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'ol', 'ul', 'li'],
      ALLOWED_ATTR: []
    })

    return (
      <div
        className={`${styles.text} ${styles.section} ${styles.richText}`}
        style={style}
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      />
    )
  }

  // Fallback to pre tag for backward compatibility
  return (
    <Text className={styles.section} style={style}>
      {children}
    </Text>
  )
}

export { Text, SectionText }
